import * as Types from '../../../models.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteHairMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteHairMutation = { deleteHair: { filename?: string | null, frontLink?: string | null } };


export const DeleteHairDocument = gql`
    mutation DeleteHair($id: String!) {
  deleteHair(id: $id) {
    filename
    frontLink
  }
}
    `;
export type DeleteHairMutationFn = Apollo.MutationFunction<DeleteHairMutation, DeleteHairMutationVariables>;

/**
 * __useDeleteHairMutation__
 *
 * To run a mutation, you first call `useDeleteHairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHairMutation, { data, loading, error }] = useDeleteHairMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHairMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHairMutation, DeleteHairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHairMutation, DeleteHairMutationVariables>(DeleteHairDocument, options);
      }
export type DeleteHairMutationHookResult = ReturnType<typeof useDeleteHairMutation>;
export type DeleteHairMutationResult = Apollo.MutationResult<DeleteHairMutation>;
export type DeleteHairMutationOptions = Apollo.BaseMutationOptions<DeleteHairMutation, DeleteHairMutationVariables>;